console.log("product-dejavu.js");

function setProductCookie(productId) {
  const cookieName = "recentProducts";
  const maxItems = 6;

  // Fonction pour obtenir la valeur du cookie
  function getCookie(name) {
    const cookieValue = document.cookie
      .split("; ")
      .find((row) => row.startsWith(name + "="))
      ?.split("=")[1];
    return cookieValue ? JSON.parse(decodeURIComponent(cookieValue)) : [];
  }

  // Fonction pour définir le cookie avec une liste de produits
  function setCookie(name, value, days = 30) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + encodeURIComponent(JSON.stringify(value)) + ";" + expires + ";path=/";
  }

  // Récupérer les produits stockés dans le cookie
  let productList = getCookie(cookieName);

  // Si le produit est déjà dans la liste, on le retire
  productList = productList.filter((id) => id !== productId);

  // Ajouter le nouveau produit au début de la liste
  productList.unshift(productId);

  // Limiter la liste à 4 produits
  if (productList.length > maxItems) {
    productList.pop();
  }

  // Mettre à jour le cookie
  setCookie(cookieName, productList);
}

// Fonction pour vérifier si la section doit être masquée
function checkAndHideDejavuSection() {
  const cookieName = "recentProducts";
  const section = document.querySelector('.product-dejavu');

  if (!section) return;

  // Fonction pour obtenir la valeur du cookie
  function getCookie(name) {
    const cookieValue = document.cookie
      .split("; ")
      .find((row) => row.startsWith(name + "="))
      ?.split("=")[1];
    return cookieValue ? JSON.parse(decodeURIComponent(cookieValue)) : [];
  }

  const productList = getCookie(cookieName);

  console.log("Checking cookie for section visibility:", productList);

  // Si aucun cookie ou liste vide, masquer la section
  if (!productList || productList.length === 0) {
    console.log("No products in cookie, hiding section");
    section.style.display = 'none';
  } else {
    console.log("Products found in cookie, showing section");
    section.style.display = 'block';
  }
}

// Vérifier et masquer la section au chargement
document.addEventListener('DOMContentLoaded', function() {
  checkAndHideDejavuSection();
});

// Mettre à jour le cookie et vérifier la section
if (window.productData && window.productData.handle) {
  setProductCookie(window.productData.handle);
  // Re-vérifier la section après avoir mis à jour le cookie
  setTimeout(checkAndHideDejavuSection, 100);
}
